const validations: ((value: string, repeatValue: string) => boolean)[] = [
  (value) => value.length >= 6,
  (value) => /\d/.test(value),
  (value) => /[A-Z]/.test(value),
  (value) => /[a-z]/.test(value),
  (value) => value.length >= 1 && !/\s/g.test(value),
  (value, matchValue) => value.length > 0 && matchValue.length > 0 && value === matchValue
];

export { validations };
